import { Platform } from 'react-native';
import { ROUTE } from "../../../routes";
import SharedPropsService, { BUILD_TYPE, getBuildType } from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { getApplicationId, getParameters, isFromAndroidWebview, nextStepCredStepper } from "../../../configs/utils";
import _ from 'lodash';
import { CONTEXT } from '../../../configs/constants';
import AsyncStorage from '@react-native-async-storage/async-storage';
const SUCCESS = 'SUCCESS';
const DEVIATION = 'DEVIATION';
const REJECTED = 'REJECTED';
let hasNavigate = false;
export const CameraConfirmAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CAMERA_CAPTURE);
};
export const GoBackAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const retakePhoto = async (action, _datastore, { setDatastore, navigate, instrumentTrack }) => {
    instrumentTrack('CAPTURE_SELFIE_RETAKE_BUTTON_CLICKED');
    await setDatastore(ROUTE.CAMERA_CAPTURE, 'camera', {
        isShowVideo: true,
    });
    await navigate(ROUTE.CAMERA_CAPTURE);
};
export const photoVerification = async (action, _datastore, { network, navigateWithClear, setDatastore, showPopup, instrumentTrack, navigate }) => {
    await setDatastore(action.routeId, 'kycPhotoInit', {
        loading: true,
    });
    const userSelfieImage = action.payload.base64Image;
    if (userSelfieImage === null) {
        await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
            showPhotoVerificationErrorCard: true,
            errorTitle: "Capture selfie again",
            errorMessage: "Empty selfie image detected, please retake selfie.",
            counter: Math.random()
        });
    }
    else {
        const user = await SharedPropsService.getUser();
        const imageName = `${user.linkedApplications[0].applicationId}_${user.linkedBorrowerAccounts[0].accountHolderPhoneNumber}.txt`;
        let applicationId = '';
        if (await AsyncStorage.getItem("application_id")) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            const user = await SharedPropsService.getUser();
            applicationId = user.linkedApplications[0].applicationId;
        }
        /** Generate Image Upload Link */
        const imageUploadLinkResponse = await network.post(api.photoInit, {
            applicationId: applicationId,
            imageName,
            imageType: 'image/jpeg',
        }, { headers: await getAppHeader() });
        if (imageUploadLinkResponse.status === 200) {
            /** Image Link Generated Successful **/
            if (!imageUploadLinkResponse.data.stepResponseObject)
                return;
            /** Upload Image to Generated Link **/
            const imageUploadResponse = await network.put(imageUploadLinkResponse.data.stepResponseObject, action.payload.base64Image, {
                headers: { 'Content-Type': 'image/jpeg' },
            });
            if (imageUploadResponse.status === 200) {
                /** Image Uploaded Successfully **/
                const imageVerifyResponse = await network.post(api.photoVerify, {
                    applicationId: applicationId,
                }, { headers: await getAppHeader(),
                    handleFromMF: true });
                if (imageVerifyResponse.status === 200) {
                    await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
                        showPhotoVerificationErrorCard: false,
                        errorTitle: "",
                        errorMessage: "",
                        counter: Math.random(),
                    });
                    const status = imageVerifyResponse?.data?.stepResponseObject?.status;
                    const context = imageVerifyResponse?.data?.stepResponseObject?.context;
                    await SharedPropsService.setPhotoVerifyInitV2(imageVerifyResponse?.data);
                    if (status === SUCCESS) {
                        user.linkedApplications[0] = _.get(imageVerifyResponse, 'data.updatedApplicationObj');
                        await SharedPropsService.setUser(user);
                        instrumentTrack('LOAN_APPLICATION_SUBMIT_BUTTON_CLICKED');
                        if (context === CONTEXT.PARTNER.toLowerCase()) {
                            setTimeout(async () => {
                                !hasNavigate &&
                                    navigate(ROUTE.MFD_SHARE_LINK_INIT, { showEndJourney: true });
                            }, 3000);
                        }
                        else {
                            const routeObj = await nextStepCredStepper();
                            setTimeout(async () => {
                                !hasNavigate &&
                                    navigateWithClear(routeObj.routeId, routeObj.params);
                            }, 3000);
                        }
                        await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
                            kycPhotoUploadSuccess: true,
                        });
                    }
                    else if (status === DEVIATION) {
                        await navigateWithClear(ROUTE.PHOTO_MISMATCH);
                        // await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", <KycInitProps>{
                        //     loading: false
                        // })
                    }
                    else if (status === REJECTED) {
                        // await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", <KycInitProps>{
                        //     loading: false
                        // })
                        const errorTitle = imageVerifyResponse?.data?.stepResponseObject?.error?.errorTitle;
                        const errorMessage = imageVerifyResponse?.data?.stepResponseObject?.error?.errorMessage;
                        await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
                            showPhotoVerificationErrorCard: true,
                            errorTitle: errorTitle,
                            errorMessage: errorMessage,
                            counter: Math.random()
                        });
                    }
                }
                else {
                    // await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", <KycInitProps>{
                    //     loading: false
                    // })
                    const errorMessage = imageVerifyResponse?.response?.data?.message;
                    await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
                        showPhotoVerificationErrorCard: true,
                        errorTitle: "Verification failed",
                        errorMessage: errorMessage,
                        counter: Math.random()
                    });
                }
            }
        }
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    let isFromTdl = false;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        if (params.platform === "TATADIGITAL" /* AppPlatform.TDL */) {
            isFromTdl = true;
        }
        if (isFromAndroidWebview() && isFromTdl) {
            window.open("FAQ_CLICKED", "_parent");
            //@ts-ignore
        }
        else {
            await navigate(ROUTE.CONTACT_US_CARD);
        }
        // @ts-ignore
        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("FAQ");
    }
    else {
        await navigate(ROUTE.CONTACT_US_CARD);
    }
};
export const successVerification = async (action, _datastore, { goBack, navigate }) => {
    hasNavigate = true;
    const photoVerify = await SharedPropsService.getPhotoVerifyInitV2();
    if (photoVerify
        && photoVerify?.stepResponseObject?.status === SUCCESS
        && photoVerify?.stepResponseObject?.context === CONTEXT.PARTNER.toLowerCase()) {
        navigate(ROUTE.MFD_SHARE_LINK_INIT, { showEndJourney: true });
    }
    else {
        const routeObj = await nextStepCredStepper();
        navigate(routeObj.routeId, routeObj.params);
    }
};
export const onModalCloseAction = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
        loading: false
    });
};
export const generateShareLinkV2Utils = async ({ setDatastore, network }) => {
    const user = await SharedPropsService.getUser();
    const application_id = await getApplicationId();
    const platform = user?.linkedPlatformAccounts[0]?.platformCode || null;
    let appDomain = '';
    const buildType = getBuildType();
    switch (buildType) {
        case BUILD_TYPE.BORROWER_PRODUCTION:
            appDomain = 'app.voltmoney.in';
            break;
        case BUILD_TYPE.BORROWER_STAGING:
            appDomain = 'app.staging.voltmoney.in';
            break;
        case BUILD_TYPE.BORROWER_QA_STAGING:
            appDomain = 'qa.staging.voltmoney.in';
            break;
        case BUILD_TYPE.BORROWER_TEST_STAGING:
            appDomain = 'test.staging.voltmoney.in';
            break;
        case BUILD_TYPE.BORROWER_LMS_STAGING:
            appDomain = 'lms.staging.voltmoney.in';
            break;
        case BUILD_TYPE.BORROWER_LOS_STAGING:
            appDomain = 'los.staging.voltmoney.in';
            break;
        default:
            appDomain = 'app.staging.voltmoney.in';
    }
    //HANDLE FOR PLATFORMS
    const platformExcludeList = ['VOLT_MOBILE_APP', 'VOLT_WEB_APP', 'VOLT_API_UAT', 'VOLT_API_INTEGRATION'];
    if (platform && !platformExcludeList.includes(platform)) {
        appDomain = appDomain + `/partnerplatform?platform=${platform}`;
    }
    await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
        onClickShareLinkLoading: true
    });
    const response = await network.post(`${api.generateShareLink}`, {
        applicationId: application_id,
        stepId: 'KYC_PHOTO_VERIFICATION',
        appDomain: appDomain
    }, {
        headers: await getAppHeader()
    });
    if (response?.status === 200) {
        await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
            shareLinkUrl: response?.data?.shortUrl,
            onClickShareLinkLoading: false
        });
        return response?.data?.shortUrl;
    }
    else {
        return null;
    }
};
export const generateShareLink = async (action, _datastore, { network, setDatastore }) => {
    // const user = await SharedPropsService.getUser()
    // const application_id = await getApplicationId();
    // let appDomain = ''
    // const buildType = getBuildType()
    // switch(buildType) {
    //     case BUILD_TYPE.BORROWER_PRODUCTION:
    //         appDomain = 'app.voltmoney.in'
    //         break;
    //     case BUILD_TYPE.BORROWER_STAGING:
    //         appDomain = 'app.staging.voltmoney.in'
    //         break;
    //     case BUILD_TYPE.BORROWER_QA_STAGING:
    //         appDomain = 'qa.staging.voltmoney.in'
    //         break;
    //     case BUILD_TYPE.BORROWER_TEST_STAGING:
    //         appDomain = 'test.staging.voltmoney.in'
    //         break;
    //     case BUILD_TYPE.BORROWER_LMS_STAGING:
    //         appDomain = 'lms.staging.voltmoney.in'
    //         break;
    //     case BUILD_TYPE.BORROWER_LOS_STAGING:
    //         appDomain = 'los.staging.voltmoney.in'
    //         break;
    //     default:
    //         appDomain = 'app.staging.voltmoney.in'        
    // }
    // await setDatastore(
    //     ROUTE.KYC_PHOTO_VERIFICATION, 
    //     "kycPhotoInit", 
    //     <KycInitProps>{
    //         onClickShareLinkLoading: true
    //     }
    // )
    // const response = await network.post(`${api.generateShareLink}`, {
    //     applicationId: application_id,
    //     stepId: user?.linkedApplications[0]?.currentStepId,
    //     appDomain: appDomain
    // }, {
    //     headers: await getAppHeader()
    // })
    // if(response?.status === 200) {
    //     await setDatastore(
    //         ROUTE.KYC_PHOTO_VERIFICATION, 
    //         "kycPhotoInit",
    //         <KycInitProps>{
    //             shareLinkUrl: response?.data,
    //             onClickShareLinkLoading: false
    //         }
    //     )
    // }
};
export const shareWhatsapplink = async (action, _datastore, { setDatastore, network }) => {
    console.warn("*** shareWhatsapplink ***", action);
    const link = await generateShareLinkV2Utils({ setDatastore, network });
    // const link = action?.payload?.link;
    const user = await SharedPropsService.getUser();
    let borrowerName = user?.user?.fullName;
    let referalLink = link;
    let partnerName = user?.linkedPartnerAccounts[0]?.partnerName || 'testPartnerName'; // Replace with your partner's name
    let message = `Dear ${borrowerName},\n\nAs part of the KYC process, please complete the selfie verification step at your earliest convenience. Click the link below to proceed:\n\n${referalLink}\n\nThis step is essential to finalize your application. If you have any questions, feel free to reach out. \n\nThank you,\n${partnerName}`;
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
};
export const copyLinkToClipboard = async (action, _datastore, { setDatastore, network, clipboard }) => {
    console.warn("*** copyLinkToClipboard ***");
    const link = await generateShareLinkV2Utils({ setDatastore, network });
    clipboard.set(link);
};
